import { cx, css } from '@linaria/core';
import { flex, theming } from 'styles/utils';
import { base } from 'styles/variables';
import { HEADER_HEIGHT } from 'styles/constants';
export const appBody = "omponents__PageWrapper__styles_ts-appBody-a1v7jsqp";
export const main = "omponents__PageWrapper__styles_ts-main-m1ih8qcg";
export const content = cx("omponents__PageWrapper__styles_ts-content-c4jdjov", flex.init, flex.direction.column, flex.alignItems.center);

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");